import { createClient } from "contentful";

const client = createClient({
  space: "4phptj66e4pz",
  accessToken: "VJcFMpvnxitZW8IegaKAN-QWDBVRSaxRLitL-naQR_I"
});

/**
 * Get an entry by ID
 * @param {String} id
 */
export const getEntry = async id => {
  return await client.getEntry(id);
};

/**
 * Get an entries by ID
 * @param {String} content_type
 */
export const getEntries = async content_type => {
  return await client.getEntries({ content_type });
};
